import script from "./StepPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./StepPassword.vue?vue&type=script&setup=true&lang=js"

import "./StepPassword.vue?vue&type=style&index=0&id=11a5d54a&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11a5d54a"]])

export default __exports__